import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.config.productionTip = false

async function init () {
  router.beforeEach(async (to, from, next) => {
    if (!store.getters['getAuthData'].token) {
      const accessToken = localStorage.getItem('access_token')
      if (accessToken) {
        store.commit('setTokenData', accessToken)
      }
    }
    if (store.getters['getIsTokenActive']) {
      store.commit('setIsAuthenticated', true)
    } else {
      store.commit('setIsAuthenticated', false)
    }
    if ((to.path !== '/corp_admin/login' && !store.getters.getIsAuthenticated)) {
      if (to.path === '/corp_admin/reset-password') {
        return next()
      }
      if (to.path.includes('/corp_admin/reset-password/')) {
        return next()
      }
      return next('/corp_admin/login')
    } else {
      return next()
    }
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

init()



// WEBPACK FOOTER //
// ./src/main.js